import Layout from "../components/Layout";
import PageHeader from "../components/PageHeader";

const Spacer = () => {
  return (
    <div className="mt-6 mb-6 text-center text-red-500 w-full">
      <svg
        fill="currentColor"
        viewBox="0 0 20 20"
        className="inline-block w-6 h-6"
      >
        <path
          fill-rule="evenodd"
          d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </div>
  );
};

export default function Pricing() {
  return (
    <Layout title="Our Story">
      <PageHeader label="Our story" />
      <div className="mt-3 max-w-screen-lg mx-auto px-6 sm:px-6 lg:px-8 text-2xl text-gray-800 font-medium leading-8">
        <p className="text-3xl leading-9 font-extrabold text-gray-800 sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-none mb-6 sm:mb-8 text-center">
          Eventive started with a question that has become our mission.
        </p>
        <p className="mb-4">
          How can we make independent film more accessible to more people?
        </p>
        <p className="mb-4">
          Film festivals had been too exclusive for too long. You had to be in
          the know just to be able to go.
        </p>
        <p className="mb-4">
          The first barrier to access was ticketing. A notorious source of
          confusion and frustration for festival goers and operators alike. And
          even if you figured out how to get a ticket, there was no guarantee
          that you would have a seat.
        </p>
        <p className="mb-4">
          There ought to be a way for passholders and single ticket buyers to
          reserve seats from the same inventory and actually have a seat
          reserved for them, right? Wrong. That functionality didn’t exist.
        </p>
        <Spacer />
        <p className="mb-4">
          So Iddo Patt, filmmaker and founding board member of the Indie Memphis
          Film Festival, asked his son Theo, then a 15-year-old high school
          student, to find a solution. Theo built Eventive.
        </p>
        <p className="mb-4">
          Theo envisioned a pass and ticketing hub that would also serve as the
          basis for engaging old and new audiences and festivals. Unfolding our
          core guiding truth:{" "}
          <span className="italic font-bold">
            the film festival starts online.
          </span>
        </p>
        <p className="mb-4">
          With its enticing new mobile-friendly schedule and film guide, Indie
          Memphis attendance increased dramatically. And other festivals took
          notice.
        </p>
        <p className="mb-4">
          Together with our first seven partner festivals, we launched Eventive
          out of beta at Art House Convergence 2018. Within two years, we were
          serving some 130 partner festivals and exhibitors around the world.
        </p>
        <p className="mb-4">
          Every one of our partners had unique priorities and needs. Simply
          listening to them taught us a lot. Their collective wisdom and
          knowledge have translated into a highly responsive and robust
          platform. With extras like online balloting being added along the way.
        </p>
        <Spacer />
        <p className="mb-4">
          Then came the global pandemic, and with it the total shutdown of
          cinema exhibition around the world.
        </p>
        <p className="mb-4">
          Once again, our mission compelled us to find a way to connect
          audiences to the films we love.{" "}
        </p>
        <p className="mb-4">
          In just a few months, the Eventive virtual screening platform emerged
          and soon became the world’s leading provider of secure, ticketed,
          on-demand and live-stream virtual screenings. For festivals, arthouses
          and film distributors.
        </p>
        <p className="mb-4">
          Innovations since 2020 have set new standards for security and
          accessibility – with invisible forensic watermarking on all ingested
          content, VOD plus Livestreams available to make every screening a
          memorable event, and the ability for organizers to precisely control
          capacity, geographic restrictions, and pass/ticket access.
        </p>
        <p className="mb-8">What's next? Stay tuned.</p>
        <p className="mb-10 text-3xl font-bold text-center">
          &mdash; Iddo, Theo &amp; The Eventive Team
        </p>
      </div>
    </Layout>
  );
}
